// extracted by mini-css-extract-plugin
export var banner = "_6-0";
export var detail = "_6-3";
export var exitButton = "_6-4";
export var message = "_6-1";
export var title = "_6-2";